import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import ACdetails from './ACdetails';
import OrgDetails from './OrgDetails';
import ShippingAddressFile from './ShippingAddressFile';
import { useNavigate } from 'react-router-dom';
import moment from 'moment'
import SitesSurvery from './SitesSurvery';
import Extramaterial from './Extramaterial';
import LoadingAnimation from '../LoadingAnimation';
import ShippingAddressGuid from './ShippingAddressguid';
import { useParams } from "react-router-dom";
import { S3Client, PutObjectCommand, GetObjectCommand } from '@aws-sdk/client-s3';
import Table from './Table';
export default function OrderForm() {
  const navigate = useNavigate()
  const { itemId } = useParams(); // Extract itemId from the route parameters
  const [customer, setCustomer] = useState([]);
  const [CustomerData, setCustomerData] = useState();
  const [selectedOrgId, setSelectedOrgId] = useState(null);
  const [selectedOrgData, setSelectedOrgData] = useState(null);
  const [transformedAddress, setTransformedAddress] = useState(null);
  const [selectedShippingAddress, setSelectedShippingAddress] = useState(null);
  const [shippingAddresses, setShippingAddresses] = useState([]);
  const [shippingaddressorder, setShippingAddressorder] = useState()
  const [CustomerIds, setCustomerIds] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [brandName,setBrandName]=useState("")
  const [isSameAsBilling,setIsSameBilling]=useState(true)
  const [savedItems, setSavedItems] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [splitInstallationCharge, setSplitInstallationCharge] = useState(1800);  // Default Split AC charge
  const [cassetteInstallationCharge, setCassetteInstallationCharge] = useState(4000);  // Default Cassette AC charge
  const [splitRefundableCharge, setsplitRefundableCharge] = useState(5000);  // Default Split AC charge
  const [acDetails, setACDetails] = useState({
    acType: "Split",
    ton: "10",  // Updated to user-friendly labels
    plan: "3+2year",
    quantity: 1,
    subscription_plan:1349,
    depositamount: 5000,
    installetionCharge: 1800,
    extraCharge: 349,
    itemId: "mc_3y_1.0",
    totalSubscription: 1349,
    totalDeposit: 5000,
    totalInstallation: 1800,
    priceAfter3Years: 899,
    totalAfter3Years: 899,
    totalAmount: 8149
  });
  const [showSavedItems, setShowSavedItems] = useState(false);
  const [shippingAddress, setShippingAddress] = useState({
    line1: '',
    line2: '',
    pincode: '',
    city: '',
    state: '',
  });
  const [copiedShippingAddress, setCopiedShippingAddress] = useState(null);
  const [gstin, setgstin] = useState({
    name: '',
    number: '',
    billingName: '',
    address: "",
    phoneNumber: '', // Added phone number field
    email: ''
  });
  const [searchOrg, setSearchOrg] = useState('');
  const [billingAddress, setBillingAddress] = useState({
    line1: '',
    line2: '',
    pincode: '',
    city: '',
    state: '',
  });
  const [isChecked, SetisChecked] = useState(false);
  const [isExistingCustomer, setIsExistingCustomer] = useState(true);
  const [selectedAddressIndex, setSelectedAddressIndex] = useState(null);
  const [currentMaterial, setCurrentMaterial] = useState({
    materialType: 'copper_piping_p', 
    quantity: '1', 
    price: '449', 
    total: '449' 
  });
  const [ischecksuperadmin,setchecksuperadmin]=useState(false)
  const [contactInformation, setContactInformation] = useState({
    contactPerson: '',
    contactNumber: '',
  });
  const [selectedcustomeraddress,setselectedcustomeraddress]=useState({})
  const [editmode,seteditmode]=useState(false)
  const [bygstcustomeer,setbygstcustomer]=useState(false)

  const s3Client = new S3Client({
    region: 'ap-south-1',
    credentials: {
      accessKeyId: `${process.env.REACT_APP_S3_ACCESS_KEY}`,
      secretAccessKey: `${process.env.REACT_APP_S3_SECERET_KEY}`
    },
  });


  const custoemeriddefine = async (name) => {
    console.log(name,"checkgstinname")
    const token = `${process.env.REACT_APP_SWIPE_TOKEN}`;
    const apiUrl = `${process.env.REACT_APP_SWIPE_BASE_URL}/api/partner/v1/customer/list`;
  
    try {
      // Fetch the customer list from the API
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `${token}`
        }
      });
      // Normalize the provided name (trim and convert to lowercase)
      const normalizedProvidedName = name ? name.trim().toLowerCase() : null;
      // Check if the customer with the normalized name exists
      if (normalizedProvidedName) {
        const existingCustomer = response.data.customers.find(customer => 
          customer.name.trim().toLowerCase() === normalizedProvidedName
        );
        return existingCustomer ? existingCustomer.customer_id : null;
      } else {
        // Return the total count of customers if no name is provided
        return response.data.customers.length;
      }
  
    } catch (error) {
      console.log('Error fetching customer list:', error.message);
      return null;
    }
  };
  
  const cleanName = (name) => {
    if (!name) return '';
    return name.replace(/[^a-zA-Z0-9]/g, '').trim();
  };

  function convertToIST(date) {
    if (isNaN(date.getTime())) {
      throw new Error('Invalid date');
    }
    const istOffset = 5 * 60 + 30; // IST is UTC+5:30
    const istDate = new Date(date.getTime() + istOffset * 60 * 1000);
    return istDate;
  }
  
  const generateCustomerId = async (gstin) => {
    const existingCustomerId = await custoemeriddefine(gstin.name);
    if (existingCustomerId) {
      console.log("Existing customer found:", existingCustomerId);
      return existingCustomerId;
    }
    const gstCode = '27';
    const currentDate = moment().format('DDMMYY');
    const name = cleanName(gstin.name);
    const data1 = await custoemeriddefine(); // Get the total customer count
    const nextCustomerNumber = data1 !== null ? (data1 + 1).toString().padStart(4, '0') : '0001';
    const newCustomerId = `CL${name.substring(0, 3).toUpperCase()}${currentDate}${gstCode}${nextCustomerNumber}`;
    return newCustomerId;
  };
  const handleCustomerIdGeneration = async () => {
    try {
     
      const generatedCustomerId = await generateCustomerId(gstin);
      if(generatedCustomerId?.startsWith("CL")){
        setCustomerIds(generatedCustomerId);
      }
      
  
    } catch (error) {
      // alert("Error generating customerId:", error.message);
      console.log(gstin,"checalerafter")
    }
  };
const handleBlurget = () => {
    if (gstin.name && gstin.name.length >= 3) {
      handleCustomerIdGeneration();
    }
  };
useEffect(()=>{
  if(gstin.name.length >= 3 && bygstcustomeer===true){
    handleCustomerIdGeneration();
  }
  
},[gstin.name])


  const handleCopyToShipping = (billingData) => {
    setCopiedShippingAddress(billingData);
  };
  const handleTransformedAddress = (address) => {
    setTransformedAddress(address);
  };
  const handleACDetailsChange = (newDetails) => {
    setACDetails((prevDetails) => ({ ...prevDetails, ...newDetails }));
  };
  const handleCustomerData = (data) => {
    setCustomerData(data);
  };

  const handleOrgSelect = (orgId, orgData) => {
    setSelectedOrgId(orgId);
    setSelectedOrgData(orgData);
  };
  const handleClearSearch = () => {
    setSelectedOrgId(null);
    setSelectedOrgData(null);
    setSelectedShippingAddress(null);
  };
  useEffect(() => {
    fetchOrganizationData();
  }, []);
  const fetchOrganizationData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/customers/getall`);
      const fetchedData = Array.isArray(response.data) ? response.data : [response.data];
      setCustomer(fetchedData);
    } catch (error) {
      alert("Error fetching organization data:", error);
    }
  };


  const handleShippingAddressSelect = (address) => {
     setselectedcustomeraddress(address)
    setSelectedShippingAddress(address);
  };

  useEffect(() => {
    if (isSameAsBilling && gstin.name) {
      console.log("gst name", gstin.name)
      setBrandName(gstin.name);
    }
  }, [isSameAsBilling, gstin.name]);

  useEffect(() => {
    if (CustomerIds!==null && Object.keys(selectedcustomeraddress).length > 0) {
      const updatedAddress = {
        ...selectedcustomeraddress,
        contactPerson: contactInformation.contactPerson,
        contactNumber: contactInformation.contactNumber,
      };
  
      axios
        .put(`${process.env.REACT_APP_BASE_URL}/api/customer/customers/${CustomerIds}/shipping-address`, updatedAddress)
        .then((res) => {
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [contactInformation.contactPerson,contactInformation.contactNumber,selectedcustomeraddress]);


  const backendcustomercreation = async () => {
    
    const formattedAddress = {
      location: `${billingAddress.line1}, ${billingAddress.line2}`,  // Combine line1 and line2
      city: billingAddress.city,
      state: billingAddress.state,
      pin: billingAddress.pincode,  // Pin becomes the pincode
    };
    const data = {
      name: gstin.name,
      customer_id: CustomerIds,
      userid: null,
      superadminphone: gstin.phoneNumber,
      superadminname: gstin.billingName,
      email: gstin.email,
      gstin: {
        number: gstin.number,
        billingName: gstin.name,
        address: formattedAddress,
      },
      shipping_address: selectedcustomeraddress,
    };

    try {
      setIsLoading(true)
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_URL}/api/customer/save`,
        method: "POST",
        data: data,
      });
      try {
        setIsLoading(false)
      } catch (secondApiError) {
        setIsLoading(false)
        alert("Error in Swipe API call:", secondApiError.message);
      }
    } catch (firstApiError) {
      setIsLoading(false)
      alert("Error in first API call:", firstApiError.message);
    }
  };
  useEffect(() => {
    const fetchPreOrderData = async () => {
      if (itemId !== undefined) {
        try {
          const response = await axios({
            url: `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${itemId}`,
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          });
          console.log(response.data,"checkdata")
          const res = response.data;
          setShowSavedItems(true);
          // Transforming AC details
          const transformedAcDetails = res.AcDetails.map((item) => ({
            acType: item.ac_type,
            ton: item.model.replace(/^[SC]/, ""), // Remove leading 'S' or 'C'
            plan: item.plan_year,
            quantity: item.quantity,
            subscription_plan: item.subscription_price,
            depositamount: item.deposit,
            installetionCharge: item.installation_price,
            totalSubscription: item.subscription_price * item.quantity,
            totalDeposit: item.deposit * item.quantity,
            totalInstallation: item.installation_price * item.quantity,
            priceAfter3Years: item.fixedPriceAfter3Years,
            totalAfter3Years: item.fixedPriceAfter3Years * item.quantity,
            totalAmount:
              item.subscription_price * item.quantity +
              item.deposit * item.quantity +
              item.installation_price * item.quantity,
            fixedPriceAfter3Years: item.fixedPriceAfter3Years,
            id: Date.now() + Math.floor(Math.random() * 1000), // Unique ID
          }));
          setSavedItems(transformedAcDetails);
  
          // Transforming materials details
          const transformedMaterials = res.materialsdetails.map((material) => ({
            materialType: material.material_name,
            quantity: Number(material.quantity),
            price: Number(material.material_price),
            totalAmount: Number(material.quantity) * Number(material.material_price),
          }));
          setMaterials(transformedMaterials);
  
          // Setting customer details
          setIsExistingCustomer(true);
          setCustomerIds(res.customer.customer_id);
  
          setContactInformation({
            contactNumber: res.customer_shipping_address.contactNumber,
            contactPerson: res.customer_shipping_address.contactPerson,
          });
  
          setgstin({
            name: res.customer.name,
            email: res.customer.email,
            phoneNumber: res.customer.mobile,
            billingName: res.superAdmin,
            number: res.customer_billing_address.gst_number
          });
  
          // setBrandName(res.superAdmin);
          setSearchOrg(res.customer.name);
  
          const selectedAddress = {
            line1: res.customer_shipping_address.address_line1,
            line2: res.customer_shipping_address.address_line2,
            city: res.customer_shipping_address.city,
            state: res.customer_shipping_address.state,
            pincode: res.customer_shipping_address.pincode,
          };
          const billingAddressData={
            line1:res.customer_billing_address.address_line1,
            line2:res.customer_billing_address.address_line2,
            city:res.customer_billing_address.city,
            state:res.customer_billing_address.state,
            pincode:res.customer_billing_address.pincode
          }
          setShippingAddresses([selectedAddress]);
          setBillingAddress(billingAddressData||selectedAddress);
          handleShippingAddressSelect(selectedAddress)
          setSelectedAddressIndex(0)
          seteditmode(true)
        } catch (error) {
          console.error("Error fetching pre-order data:", error);
          // Optional: Show user-friendly error message
        }
      }
    };
  
    fetchPreOrderData();
  }, [itemId]); // Add `itemId` as a dependency
  
  const createInstallationItem = (type, quantity, charge, itemId) => {
    if (quantity > 0 && charge > 0) { // Check if charge is also valid
      const unitPrice = charge / 1.28; // This assumes 28% tax

      return {
        id: itemId,
        name: `Installation (${type} AC)`,
        quantity: quantity,
        unit_price: unitPrice,
        tax_rate: 28,
        price_with_tax: charge,
        item_type: 'Service',
        net_amount: unitPrice * quantity,
        total_amount: charge * quantity,
      };
    }
    return null; // Return null if quantity or charge is invalid
  };
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const mapProduct = (acModel, item) => {
    const models = {
      '10': {
        id: 'mlmc_3y_1t_p',
        name: 'Monthly Leasing and Maintenance charges of Air Conditioner - 1T',
        unitPrice: 1014.84,
        priceWithTax: 1299,
      },
      '15': {
        id: 'mlmc_3y_1.5t_p',
        name: 'Monthly Leasing and Maintenance charges of Air Conditioner - 1.5T',
        unitPrice: 1092.97,
        priceWithTax: 1399,
      },
      '20': {
        id: 'mlmc_3y_2t_p', // Default for Split
        name: 'Monthly Leasing and Maintenance charges of Air Conditioner - 2T',
        unitPrice: 1327.34,
        priceWithTax: 1699,
      },
      '30': {
        id: 'mlcmc_2y_3t_p',
        name: 'Monthly Leasing and Maintenance charges of Air Conditioner - 2Y 30T',
      }
    };
    if (item.acType === 'Cassette') {
      models['20'] = {
        id: 'mlmc_cassette_5y_2t_p',
        name: 'Monthly Leasing and Maintenance charges of Air Conditioner - 5Y 2T-Cassete',
        unitPrice: 1952.34,
        priceWithTax: 2499,
      };
      models['30'] = {
        id: 'mlmc_cassette_5y_3t_p',
        name: 'Monthly Leasing and Maintenance charges of Air Conditioner - 5Y 3T-Cassete',
        unitPrice: 2342.96,
        priceWithTax: 2999,
      }
    }
    const model = models[acModel];

    if (!model) {
      throw new Error('Invalid acModel provided.');
    }

    let priceWithTax = Number(item.totalSubscription / item.quantity);
    let unitPrice = (item.totalSubscription / item.quantity) / 1.28;
    return {
      id: model.id,
      name: model.name,
      quantity: item.quantity,
      unit_price: unitPrice,
      tax_rate: 28,
      price_with_tax: priceWithTax,
      item_type: 'Service',
      net_amount: unitPrice * item.quantity,
      total_amount: item.totalSubscription
    };
  };

  const mapMaterial = (items) => {
    const materials = {
      "copper_piping_p": {
        "id": "copper_piping_p",
        "name": "Extra Installation - Piping",
        "unit_price": 350.728,
        "price_with_tax": 448.93184,
      },
      "copper_piping_cassette_p": {
        "id": "copper_piping_cassette_p",
        "name": "Extra Installation-Cassette - Piping",
        "unit_price": 350.728,
        "price_with_tax": 448.93184,
      },

      "core_cable_4_p": {
        "id": "core_cable_4_p",
        "name": "Polycab 4 Core Cable",
        "unit_price": 39.006,
        "price_with_tax": 49.92768,
      },
      "dismantling_charges_p": {
        "id": "dismantling_charges_p",
        "name": "Dismantling charges",
        "unit_price": 390.625,
        "price_with_tax": 500.0
      },
      "cross_stand_p": {
        "id": "cross_stand_p",
        "name": "Cross Stand",
        "unit_price": 1483.59,
        "price_with_tax": 1898.9952
      },
      "rubber_stand_p": {
        "id": "rubber_stand_p",
        "name": "Extra Installation - Rubber Stand",
        "unit_price": 233.59,
        "price_with_tax": 298.9952
      },
      "l_stand_p": {
        "id": "l_stand_p",
        "name": "L Stand",
        "unit_price": 467.97,
        "price_with_tax": 599.0016,
      },
      "jumbo_stand":{
        "id": "jumbo_stand",
        "name": "Jumbo Stand",
        "unit_price": 858.59375,
        "price_with_tax": 1099,
      },
      "uninstall_cassette_charges":{
        "id": "uninstall_cassette_charges",
        "name": "Uninstallation Charges_Cassette",
        "unit_price": 1171.875,
        "price_with_tax": 1500,
      },
      "add_on_split":{
        "id": "add_on_split",
        "name": "Add On Service - Split",
        "unit_price": 499,
        "price_with_tax": 499,
      },
      "add_on_cassette":{
        "id": "add_on_cassette",
        "name": "Add On Service - Cassette",
        "unit_price": 1499,
        "price_with_tax": 1499,
      },
      "relocation_cassette":{
        "id": "relocation_cassette",
        "name": "Relocation - Cassette",
        "unit_price": 5000,
        "price_with_tax": 5000,
      },
      "relocation_split":{
        "id": "relocation_split",
        "name": "Relocation - Split",
        "unit_price": 2000,
        "price_with_tax": 2000,

      }

    };

    // Check if items is an array
    if (!Array.isArray(items)) {
      alert('Expected an array but got:', items);
      return []; // Return an empty array instead of null
    }

    // Map over the provided items and dynamically build the material objects
    return items.map((item) => {
      const material = materials[item.materialType.toLowerCase().replace(/\s+/g, '_')];
      if (!material) {
        alert("Material type not found for:", item.materialType);
        return null; // If no matching material is found, return null
      }

      // Ensure quantity and price are numbers
      const quantity = Number(item.quantity);
      const price = Number(item.price);
      let priceWithTax = Number(item.totalAmount / quantity)
      let unitPrice = priceWithTax / 1.28;
      return {
        id: material.id,
        name: material.name,
        quantity: quantity, // Correctly formatted quantity
        unit_price: unitPrice, // Static unit price from materials
        tax_rate: 28, // Static tax rate
        price_with_tax: priceWithTax, // Total amount from input
        item_type: 'Product', // Static type 'Material'
        net_amount: unitPrice * quantity, // Net amount excluding tax
        total_amount: item.totalAmount // Total amount with tax
      };
    }).filter(item => item !== null); // Filter out any null values if materials are not found
  };
  const mapRefundableDeposit = (acModel, ton, duration, quantity, totalAmount) => {
    const refundableDeposits = {
      'Split': {
        '3year': {
          '10': {
            id: 'refund_3y_1t_p',
            name: 'Refundable Deposit - 1T',
          },
          '15': {
            id: 'refund_3y_1.5t_p',
            name: 'Refundable Deposit - 1.5T',
          },
          '20': {
            id: 'refund_3y_2t_p',
            name: 'Refundable Deposit - 2T',
          },
        },
        '5years': {
          '10': {
            id: 'refund_5y_1t_p',
            name: 'Refundable Deposit - 1T',
          },
          '15': {
            id: 'refund_5y_1.5t_p',
            name: 'Refundable Deposit - 1.5T',
          },
          '20': {
            id: 'refund_5y_2t_p',
            name: 'Refundable Deposit - 2T',
          },
        },
      },
      'Cassette': {
        '20': {
          id: 'refund_cassette_2t_p',
          name: 'Refundable Deposit - Cassette 2 Ton',
        },
        '30': {
          id: 'refund_cassette_3t_p',
          name: 'Refundable Deposit - Cassette 3 Ton',
        },
      },
    };
  
    // Check for valid AC model
    if (!refundableDeposits[acModel]) {
      alert(`Invalid AC model provided: ${acModel}`);
      return null;
    }
  
    let deposit;
    if (acModel === 'Split') {
      // Check for valid duration
      if (!refundableDeposits[acModel][duration]) {
        alert(`Invalid duration provided for Split AC: ${duration}`);
        return null;
      }
      // Check for valid tonnage
      deposit = refundableDeposits[acModel][duration][ton];
      if (!deposit) {
        alert(`Invalid tonnage provided for duration ${duration} in Split AC model: ${ton}`);
        return null;
      }
    } else if (acModel === 'Cassette') {
      // Check for valid tonnage
      deposit = refundableDeposits[acModel][ton];
      if (!deposit) {
        alert(`Invalid tonnage provided for Cassette AC model: ${ton}`);
        return null;
      }
    }
  
    // Calculate unit price and price with tax dynamically
   
    let priceWithTax = Number(totalAmount / quantity)
    let unitPrice = priceWithTax;
  
    return {
      id: deposit.id,
      name: deposit.name,
      quantity: Number(quantity),
      unit_price: parseInt(unitPrice.toFixed(2)),
      tax_rate: 0,
      price_with_tax: parseInt(priceWithTax.toFixed(2)),
      item_type: 'Service',
      net_amount: unitPrice*quantity,
      total_amount: totalAmount,
    };
  };



const uploadPdfToS3 = async (pdfBlob, fileName) => {
      console.log("inside the upload api");
      console.log(`${process.env.REACT_APP_AWS_BUCKET_NAME}`);
      try {
        const command = new PutObjectCommand({
          Bucket: `${process.env.REACT_APP_AWS_BUCKET_NAME}`,
          Key: `invoices/${fileName}`,
          Body: pdfBlob,
          ContentType: 'application/pdf',
        });
        const uploadResponse = await s3Client.send(command);;
        console.log('PDF uploaded successfully:', uploadResponse);
        return `https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/${fileName}`; // Return the public URL of the uploaded file
      } catch (error) {
        console.error('Error uploading PDF to S3:', error);
        throw new Error('Failed to upload PDF');
      }
    };

const updateurl = async (pdfurl, preOrderid) => {
      try {
        const res = await axios.patch(
          `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/addpilinkurl`,
          {
            preOrderid: preOrderid,
            pilink: pdfurl,
          }
        );
        console.log(res.data);
      } catch (err) {
        console.error('Error:', err);
      }
    };
  
  
  const createPIInvoice = async (savedItems, materials, customerdata, selectedShippingAddress, billingAddress, splitInstallationCharge, cassetteInstallationCharge,itemId) => {
      // Proceed with backend customer creation and invoice generation
      const currentDate = formatDate(new Date());
      const futureDate = formatDate(new Date(new Date().setFullYear(new Date().getFullYear() + 3)));

      // Mapping items for the invoice
      const invoiceItems = savedItems.map((item) => {

        return mapProduct(item.ton, item);
      });

      // Filter and calculate quantities for installation items
      const splitItems = savedItems.filter(item => item.acType === "Split");
      const cassetteItems = savedItems.filter(item => item.acType === "Cassette");

      const totalSplitQuantity = splitItems.reduce((sum, item) => sum + item.quantity, 0);
      const totalCassetteQuantity = cassetteItems.reduce((sum, item) => sum + item.quantity, 0);

      // Add installation items if applicable
      const splitInstallationItem = createInstallationItem('Split', totalSplitQuantity, splitInstallationCharge, 'install_1500_p');
      const cassetteInstallationItem = createInstallationItem('Cassette', totalCassetteQuantity, cassetteInstallationCharge, 'install_cassette_p');

      if (splitInstallationItem) {
        invoiceItems.push(splitInstallationItem);
      }
      if (cassetteInstallationItem) {
        invoiceItems.push(cassetteInstallationItem);
      }

      console.log(savedItems,"checkpiitem")
      savedItems.forEach(item => {
        const acModel = item.acType === 'Cassette' ? 'Cassette' : 'Split';
        let duration = null;
        if (acModel === 'Split') {
          duration = item.plan === "3+2year" ? "5years" : (item.plan || "5years");
        }
        const refundableItem = mapRefundableDeposit(acModel, item.ton, duration, item.quantity,item.totalDeposit);
        refundableItem.total_amount = item.depositamount * item.quantity;
        invoiceItems.push(refundableItem);
      });
      const materialItems = mapMaterial(materials);
      materialItems.forEach(material => {
        if (material) {
          invoiceItems.push(material);
        }
      });
      // Invoice details
      const invoice = {
        document_type: 'pro_forma_invoice',
        document_date: currentDate,
        customer: {
          id: customerdata.customer_id,
          name: customerdata.name,
          email: customerdata.email,
          gstin: billingAddress.gst_number,
        },
        items: invoiceItems,
        customer_shipping_address: {
          address_line1: selectedShippingAddress.address_line1,
          address_line2: selectedShippingAddress.address_line2,
          pincode: selectedShippingAddress.pincode,
          city: selectedShippingAddress.city,
          country: 'India',
          state: selectedShippingAddress.state,
        },
        // Conditionally add customer_billing_address if gstin.number exists
        customer_billing_address: {
          address_line1: billingAddress.address_line1,
          address_line2: billingAddress.address_line2,
          pincode: billingAddress.pincode,
          city: billingAddress.city,
          country: 'India',
          state: billingAddress.state,
        }
        ,
        notes: `Start Date : ${currentDate} End Date: ${futureDate}`,
        round_off: true,
      };
      // uploadInvoiceData(invoice);
      setIsLoading(true);
      const token = `${process.env.REACT_APP_SWIPE_TOKEN}`;
      const swipeResponse = await axios.post(
        `${process.env.REACT_APP_SWIPE_BASE_URL}/api/partner/v1/doc`,
        invoice,
        {
          headers: {
            Authorization: token
          }
        }
      );
      const hashId = swipeResponse.data.hashId;
      const pdfResponse = await axios.get(
        `${process.env.REACT_APP_SWIPE_BASE_URL}/api/partner/v1/doc/pdf/${hashId}`,
        {
          headers: {
            Authorization: token
          },
          responseType: 'arraybuffer'
        }
      );

      const pdfBlob = new Blob([pdfResponse.data], { type: 'application/pdf' });
       const fileName=`invoice_${hashId}.pdf`
       const pdfurl=await uploadPdfToS3(pdfBlob,fileName)
       updateurl(pdfurl,itemId)
 
 
    }

    
 
  const validatePreOrderData = () => {
    if (!CustomerIds) {
      alert("⚠️ Customer ID is missing. Please check and try again.");
      return false;
    }
    if (!gstin || !gstin.name || !gstin.email || !gstin.phoneNumber) {
      alert("⚠️ Customer information is incomplete. Please provide the name, email, and phone number. 📧📞");
      return false;
    }
    if (!gstin.billingName) {
      alert("⚠️ Superadmin name is pending. 🕵️‍♂️ Please update it before proceeding.");
      return false;
    }
    if (!brandName) {
      alert("⚠️ Brand name is missing. 🏷️ Please add the brand name.");
      return false;
    }
    if (!savedItems || savedItems.length === 0) {
      alert("⚠️ No items have been added to the invoice. 🛒 Please add items to proceed.");
      return false;
    }
    if (
      !selectedShippingAddress || 
      !selectedShippingAddress.line1 || 
      !selectedShippingAddress.city || 
      !selectedShippingAddress.state || 
      !selectedShippingAddress.pincode
    ) {
      alert("⚠️ Shipping address is incomplete. 🚚 Please provide address line, city, state, and pincode.");
      return false;
    }
    if (!contactInformation || !contactInformation.contactPerson || !contactInformation.contactNumber) {
      alert("⚠️ Contact information is incomplete. 📇 Please provide the contact person and number.");
      return false;
    }
    return true;
  };
  







console.log(savedItems,"checksaved")

const savesiteSurveyDetails = async () => {
  // Validate data before proceeding
  if (!validatePreOrderData()) return;

  try {
    backendcustomercreation();
    const formattedAddress = {
      location: `${billingAddress.line1}, ${billingAddress.line2}`,  // Combine line1 and line2
      city: billingAddress.city,
      state: billingAddress.state,
      pin: billingAddress.pincode,  // Pin becomes the pincode
    };
    console.log(savedItems,"checkinside")
    const preOrderData = {
      customer: {
        customer_id: CustomerIds,
        name: gstin.name,
        email: gstin.email,
        mobile: gstin.phoneNumber
      },
      superAdmin: gstin.billingName,
      brandName: brandName,
      AcDetails: savedItems,
      Ac_totalAmount: savedItems.reduce((sum, item) => sum + item.totalAmount, 0),
      materialsdetails: materials.map(item => ({
        material_name: item.materialType,
        material_price: item.price,
        quantity: item.quantity
      })),
      material_totalAmount: materials.reduce((sum, item) => sum + item.totalAmount, 0),
      // pending_amount: savedItems.reduce((sum, item) => sum + item.totalAmount, 0)+ materials.reduce((sum, item) => sum + item.totalAmount, 0),
    
      customer_shipping_address: {
        address_line1: selectedShippingAddress.line1,
        address_line2: selectedShippingAddress.line2,
        pincode: String(selectedShippingAddress.pincode),
        city: selectedShippingAddress.city,
        country: 'India',
        state: selectedShippingAddress.state.toUpperCase(),
        addressid: selectedShippingAddress._id,
        contactPerson: contactInformation.contactPerson,
        contactNumber: contactInformation.contactNumber
      },
      customer_billing_address: {
        gst_number:gstin.number,
        address_line1: billingAddress.line1,
        address_line2: billingAddress.line2,
        pincode: String(billingAddress.pincode),
        city: billingAddress.city,
        country: 'India',
        state: billingAddress.state.toUpperCase(),
      },
      preOrdertimestamp:  convertToIST(new Date())
    };
    setIsLoading(true);
   
    if (itemId !== undefined) {
      const preOrderResponse = await axios.put(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${itemId}/updatedetails`,
        preOrderData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('authToken')}`
          }
        }
      );
      //createPIInvoice(savedItems,materials,preOrderData.customer,preOrderData.customer_shipping_address,preOrderData.customer_billing_address,splitInstallationCharge,cassetteInstallationCharge,itemId)
      navigate('/home')
    } else {
      const preOrderResponse = await axios.post(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder`,
        preOrderData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('authToken')}`
          }
        }
      );
      
      //createPIInvoice(savedItems,materials,preOrderData.customer,preOrderData.customer_shipping_address,preOrderData.customer_billing_address,splitInstallationCharge,cassetteInstallationCharge,preOrderResponse.data._id)
      navigate('/home')
      setSavedItems([])
      setMaterials([])
    }
    setIsLoading(false);
  } catch (error) {
    console.error("Error saving pre-order details:", error);
    alert("An error occurred while saving pre-order details. Please try again.");
    setIsLoading(false);
  }
};

  return (
    <div className='space-y-6 p-6 bg-secondary min-h-screen justify-start block'>
      <h1 className="text-2xl font-bold">Order Details</h1>
      <ACdetails setShowSavedItems={setShowSavedItems} showSavedItems={showSavedItems} onACDetailsChange={handleACDetailsChange} acDetails={acDetails} setACDetails={setACDetails} savedItems={savedItems} setSavedItems={setSavedItems} setCassetteInstallationCharge={setCassetteInstallationCharge} setSplitInstallationCharge={setSplitInstallationCharge} cassetteInstallationCharge={cassetteInstallationCharge} splitInstallationCharge={splitInstallationCharge} setsplitRefundableCharge={setsplitRefundableCharge} splitRefundableCharge={splitRefundableCharge}/>

      <OrgDetails
        customer={customer}
        onOrgSelect={handleOrgSelect}
        onClearSearch={handleClearSearch}
        onCopyToShipping={handleCopyToShipping}
        onTransformedAddress={handleTransformedAddress}
        gstin={gstin}
        setgstin={setgstin}
        isChecked={isChecked}
        SetisChecked={SetisChecked}
        billingAddress={billingAddress}
        setBillingAddress={setBillingAddress}
        setIsExistingCustomer={setIsExistingCustomer}
        isExistingCustomer={isExistingCustomer}
        setCustomerIds={setCustomerIds}
        setchecksuperadmin={setchecksuperadmin}
        ischecksuperadmin={ischecksuperadmin}
        contactInformation={contactInformation} 
        setContactInformation={setContactInformation}
        handleBlurget={handleBlurget}
        handleCustomerIdGeneration={handleCustomerIdGeneration}
        setBrandName={setBrandName}
        brandName={brandName}
        setIsSameBilling={setIsSameBilling}
        isSameAsBilling={isSameAsBilling}
        searchOrg={searchOrg}
        setSearchOrg={setSearchOrg}
        setShippingAddresses={setShippingAddresses}
        editmode={editmode}
        seteditmode={seteditmode}
        setbygstcustomer={setbygstcustomer}
      />
      <ShippingAddressFile
        selectedOrgId={selectedOrgId}
        onSelectAddress={handleShippingAddressSelect}
        onCustomerData={handleCustomerData}
        shippingAddress={shippingAddress}
        setShippingAddress={setShippingAddress}
        onTransformedAddress={handleTransformedAddress}
        copiedShippingAddress={copiedShippingAddress}
        setShippingAddressorder={setShippingAddressorder}
        shippingaddressorder={shippingaddressorder}
        setShippingAddresses={setShippingAddresses} 
        shippingAddresses={shippingAddresses}
        contactInformation={contactInformation}
        setSelectedAddressIndex={setSelectedAddressIndex}
        selectedAddressIndex={selectedAddressIndex}
      />
      <ShippingAddressGuid contactInformation={contactInformation} setContactInformation={setContactInformation} />
      <Table data={savedItems} onSave={setSavedItems}/>
      {/* <SitesSurvery   siteSurvey={siteSurvey} setSiteSurvey={setSiteSurvey}/> */}
      <div className="space-x-4 p-4">
        {isLoading && (
        <div className="fixed inset-0 bg-gray-50 bg-opacity-70 overflow-y-auto h-full w-full flex items-center justify-center">
             <LoadingAnimation /> 
        </div>
      )} 
       {itemId!==undefined ? <button className='bg-white text-primary py-2 px-4 border border-primary m-1 md:m-0' onClick={savesiteSurveyDetails}> Update Details</button>:<button className='bg-white text-primary py-2 px-4 border border-primary m-1 md:m-0' onClick={savesiteSurveyDetails}> Save Details</button>}
      
      </div>
      
    </div>
  );
}